<template>
    <div style="margin-bottom:15px;margin-top:15px;">
        <div v-for="model in question.answers" v-bind:key="model.uid">
            <label
                    :for="question.uid" v-bind:class="{ selected: model.selected }">
            </label>
            <input v-model="model.value"
                   class="form-control"
                   :placeholder="model.title"
                   :name="question.uid"
                    v-bind:maxlength="question.config.max_length"
                    v-bind:type="question.config.only_numbers ? 'email' : 'text'"
                    v-bind:min="question.config.only_numbers ? 0 : ''"
                    v-bind:max="question.config.only_numbers ? question.config.max_length : ''"
                    v-mask="question.config.input_mask"
                    >
        </div>
    </div>
</template>

<script>
    export default {
        name: 'text-field',
        props: ['question'],
        data() {
            return {}
        },
        methods: {},
        components: {}
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>
